import React, { useCallback, useState } from "react";
import classes from "./ApiConfigModal.module.css";

// Shared "DTM API Configuration URL" modal. Driven by a plain `url` string so it
// can be reused anywhere the URL is known (map drill-down, AI data sources, ...).
const ApiConfigModal = ({ open, url, onClose }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(url).catch(() => {});
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }, [url]);

  if (!open) return null;

  return (
    <div className={classes.api_modal_overlay} onClick={onClose}>
      <div
        className={classes.api_modal}
        role="dialog"
        aria-modal="true"
        aria-label="DTM API Configuration URL"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className={classes.api_modal_close}
          aria-label="Close"
          onClick={onClose}
        >
          &times;
        </button>
        <h3 className={classes.api_modal_title}>DTM API Configuration URL</h3>
        <div className={classes.api_modal_url}>
          <span className={classes.api_modal_url_text}>{url}</span>
          <button
            type="button"
            className={classes.api_modal_copy}
            onClick={handleCopy}
            aria-label={copied ? "Copied" : "Copy URL"}
            title={copied ? "Copied!" : "Copy URL"}
          >
            {copied ? (
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="9" y="9" width="11" height="11" rx="2" />
                <path d="M5 15V5a2 2 0 0 1 2-2h10" />
              </svg>
            )}
          </button>
        </div>
        <div className={classes.api_modal_note}>
          <p>
            This is a ready-to-use DTM API query built from your current
            selection. Running it requires a subscription key, which is managed
            on the DTM API portal:
          </p>
          <ol>
            <li>
              Register on the{" "}
              <a
                href="https://dtm-apim-portal.iom.int/"
                target="_blank"
                rel="noopener noreferrer"
              >
                DTM API portal
              </a>{" "}
              and create your subscription key.
            </li>
            <li>Run the query with your key attached to get the data.</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default ApiConfigModal;
